<template>
<div class="chapter">
<div class="inner_page">
<p class="break c"> </p>
<p class="center z">This Book is Dedicated to My Mother and Father, thank you for teaching me how to do the things I would need to do as an adult to care for my family. To my wife Heather, for standing by my side, for always pushing me to be better and to do better. And to all the Men and Women over the years who have taken a part of their time, and their life to help guide me and teach me.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_dedi.vue?32082b0a